<template>
  <span :title="title">
    <span
      v-for="(chunk, index) in chunks"
      :key="'highlight' + index"
      :class="{ highlight: chunk.isHighlighted }"
    >
      {{ chunk.text }}
    </span>
  </span>
</template>

<script lang="ts">
import { defineComponent, computed, type PropType } from '@/composition/vue/compositionApi'
import { getHighlightedChunksForText, type HighlightChunk } from '@/utils/string/getHighlightedChunksForText'

export default defineComponent({
  props: {
    text: {
      type: String,
      default: '',
    },
    search: {
      type: String,
      default: '',
    },
    caseSensitive: {
      type: Boolean,
      default: false,
    },
    ignoreChars: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    title: {
      type: String,
    },
  },
  setup(props) {
    const chunks = computed<HighlightChunk[]>(() =>
      getHighlightedChunksForText(props.text, props.search, props.caseSensitive, props.ignoreChars),
    )
    return { chunks }
  },
})
</script>

<style scoped lang="scss">
.highlight {
  background: $highlight;
}
</style>
